module.exports = __webpack_public_path__ + "static/img/20011 (2).570517b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20011 (2).webp
// module id = 5Dub
// module chunks = 14